import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useOnboardingQuestionnaireLoading() {
  return useSelector(
    (state: RootState) => state.onboardingQuestionnaire.questionnaireDetailsLoading,
  );
}
